export default "__VITE_ASSET__f443e2d7__"